// extracted by mini-css-extract-plugin
export default {"footer":"rsS8c3jq5WIf3lHNh2rM__footer___","modalContainer":"wAHYVyirXyu5Yvw9X2Ge__modalContainer___"};